const MOBILE = window.matchMedia('(max-width: 989px)');

const grid = document.querySelector('.hd-pdp__grid');
const gallery = document.querySelector('.hd-pdp__gallery');

if (grid && gallery) {
  const place = () => {
    const chat = document.querySelector('.hd-chat--docked');
    if (!chat) return;

    if (MOBILE.matches) {
      if (chat.parentElement !== grid) grid.appendChild(chat);
    } else if (chat.parentElement !== gallery) {
      gallery.appendChild(chat);
    }
  };

  place();

  new MutationObserver(place).observe(gallery, { childList: true });

  if (typeof MOBILE.addEventListener === 'function') {
    MOBILE.addEventListener('change', place);
  } else if (typeof MOBILE.addListener === 'function') {
    MOBILE.addListener(place);
  }
}
